import logo from '../../imagens/logo-rio.svg'
import { Link } from 'react-router-dom';

function Logo() {
  return (
    <div className="d-flex justify-content-center h-100">
      <Link to = '/'>
        <img src={logo} alt="logo" style={{ 'width' : '100%' }}/>
      </Link>
    </div>
  );
}

export default Logo;
